import moment from 'moment'
import 'moment/locale/de'

export enum DATE_TIME_FORMAT {
  APPOINTMENT_SHORTHAND = 'DDMMHHmm',
  DATE_TIME = 'DD.MM, HH:mm',
  DATE_TIME_PAST = 'DD.MM.YYYY, HH:mm',
  DATE_FULL = 'DD.MM.YYYY',
  DATE_WITH_WEEKDAY = 'ddd DD. MMM YYYY',
  TIME = 'HH:mm',
  DATE_FULL_ISO = 'YYYY-MM-DD'
}

export type DateLikeValue = Date | string | number

export const dateParsers: Array<{
  match: (val: DateLikeValue) => boolean
  parse: (val: DateLikeValue) => Date | null
}> = [
  {
    match: (val: DateLikeValue) => typeof val === 'number',
    parse: (val: number) => new Date(val * 1000)
  },
  {
    match: (val: DateLikeValue) => typeof val === 'string' && !!val.match(/\d{8}/),
    parse: (val: string) => {
      const dt = moment(val, DATE_TIME_FORMAT.APPOINTMENT_SHORTHAND)
      return dt.isValid() ? dt.year(moment().year()).toDate() : null
    }
  },
  {
    match: () => true,
    parse: (val) => {
      return moment(val).toDate()
    }
  }
]

export const parseDate = (input: DateLikeValue): Date | null => {
  return (
    dateParsers.reduce((dt, def) => {
      if (dt) return dt
      return def.match(input) && def.parse(input)
    }, null) || null
  )
}

export const formatDateTime = (
  value: DateLikeValue,
  format?: DATE_TIME_FORMAT
): string | undefined => {
  const dt = parseDate(value)

  return dt
    ? moment(dt)
        .locale('de')
        .format(format || DATE_TIME_FORMAT.DATE_TIME)
    : undefined
}

export const formatTimeOutput = (value: DateLikeValue): string | undefined => {
  const dt = parseDate(value)
  if (!dt) {
    return undefined
  }

  const format =
    dt.getFullYear() < new Date().getFullYear()
      ? DATE_TIME_FORMAT.DATE_TIME_PAST
      : DATE_TIME_FORMAT.DATE_TIME

  return formatDateTime(value, format)
}

export const getDateWithOffset = (
  {
    years = 0,
    months = 0,
    days = 0,
    hours = 0,
    minutes = 0
  }: {
    years?: number
    months?: number
    days?: number
    hours?: number
    minutes?: number
  },
  date?: Date
) => {
  const from = date || new Date()
  const diff = new Date()
  diff.setFullYear(from.getFullYear() + years)
  diff.setMonth(from.getMonth() + months)
  diff.setDate(from.getDate() + days)
  diff.setHours(from.getDate() + hours)
  diff.setMinutes(from.getMinutes() + minutes)
  diff.setMilliseconds(0)

  return diff
}
